import AlertsListItem from "./alertsListItem";
export default AlertsListItem;
